import { render, staticRenderFns } from "./ClientStatusDialog.vue?vue&type=template&id=033a60be&scoped=true&"
import script from "./ClientStatusDialog.vue?vue&type=script&lang=ts&"
export * from "./ClientStatusDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ClientStatusDialog.vue?vue&type=style&index=0&id=033a60be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a60be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VRadio,VRadioGroup,VSelect,VTextField})
